import { render, staticRenderFns } from "./CCItemCard.vue?vue&type=template&id=3bd59fd2&"
import script from "./CCItemCard.vue?vue&type=script&lang=ts&"
export * from "./CCItemCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports